var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"faf-tag",attrs:{"variant":_vm.color,"pill":""}},[_vm._v(_vm._s(_vm.text)),_c('br'),_c('span',{staticClass:"tag--description"},[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }